module.exports = __webpack_public_path__ + "img/9788901140605.ec16327a.jpg";